import { render, staticRenderFns } from "./ConfirmReceived.vue?vue&type=template&id=13d4b8fb&scoped=true&"
import script from "./ConfirmReceived.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceived.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReceived.vue?vue&type=style&index=0&id=13d4b8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4b8fb",
  null
  
)

export default component.exports